export class ProgramsService {
  constructor(axios, apiUrl) {
    this.$axios = axios;
    this.apiUrl = apiUrl;
  }

  async getProgramById(id, sqldbid) {
      return await this.$axios.get(
          this.apiUrl + "Programs/Program/" + id + "/Company/" + sqldbid
      ).then(function(response) {
          return response.data;
      })
      .catch(function(error) {
          return {error: error, response: error.response.data };
      });
  }
  
  async searchProgramById(sqldbid, data) {
    return await this.$axios.post(
        this.apiUrl + "Programs/Search/Company/" + sqldbid, data
    ).then(function(response) {
        return response.data;
    })
    .catch(function(error) {
        return {error: error, response: error.response.data };
    });
  }
}
